import React, { useMemo, useCallback } from 'react';
import { useParams } from 'react-router-dom';
import { CatalogForm } from '../../../components/CatalogForm/CatalogForm';
import { Validators } from '../../../components/CatalogForm/validators';
import { LugarService } from '../../../services/LugarService';

const LugarForm = () => {
  const routeParams = useParams() || {};
  const id = routeParams.id || null;

  // Pre-load data in edit mode
  const loadData = useCallback(async (recordId) => {
    return await LugarService.obtenerPorId(recordId);
  }, []);

  // Submit handler
  const handleSubmit = useCallback(async (values) => {
    const payload = {
      ...values,
      id: id,
    };
    return await LugarService.guardar(payload);
  }, [id]);

  // Form field configurations
  const fields = useMemo(() => [
    {
      name: 'od_lugar',
      label: 'Clave',
      type: 'text',
      col: 6,
      required: true,
      placeholder: 'Ej. GDL o CDMX',
      validators: [Validators.required('La clave del lugar es obligatoria')],
    },
    {
      name: 'od_lugar_nombre',
      label: 'Nombre del Lugar',
      type: 'text',
      col: 6,
      required: true,
      placeholder: 'Ej. Guadalajara',
      validators: [Validators.required('El nombre del lugar es obligatorio')],
    },
  ], []);

  return (
    <CatalogForm
      title="Lugar"
      subtitle="Administración de claves y nombres de lugares para orígenes y destinos"
      fields={fields}
      initialValues={{
        od_lugar: '',
        od_lugar_nombre: '',
      }}
      id={id}
      loadData={loadData}
      onSubmit={handleSubmit}
      backUrl="/Catalogo/Lugares"
    />
  );
};

export default LugarForm;
